import { type CheckboxFieldProps, CheckboxField, get } from '@mfw/components';
import { type FieldError, Controller } from 'react-hook-form';

export type FormCheckboxFieldProps = Omit<CheckboxFieldProps, 'errors'>;

export const FormCheckboxField = ({
  defaultValue,
  disabled,
  name,
  onChange,
  ...otherProps
}: FormCheckboxFieldProps) => {
  return (
    <Controller
      render={({ field, formState: { errors, isLoading } }) => {
        const error = get<FieldError>(errors, name) ?? undefined;
        return (
          <CheckboxField
            errors={error?.message}
            {...field}
            {...otherProps}
            onChange={(e) => {
              field.onChange(e);
              onChange?.(e, e.target.checked);
            }}
            loading={otherProps?.loading || isLoading}
            checked={!!field.value}
            disabled={disabled}
          />
        );
      }}
      name={name}
    />
  );
};
